import { computed } from '@vue/composition-api'
import store from '@/store'
import { CallTriage } from '@/types/casts'
import { CastParticipantInfo } from '../types'

const requestAddParticipant = async (participant: CastParticipantInfo) => {
  await store.dispatch.casts.setCasterTriage({
    castId: participant.castId,
    userId: participant.userId,
    triage: CallTriage.Selftest
  })
  await store.dispatch.casts.addParticipantToCast({
    castId: participant.castId,
    userId: participant.userId,
    participant: { name: participant.name, lastCheckedIn: new Date() }
  })
}

const permissions = computed(() => store.state.usermedia.permissions)
const hasDeviceError = computed(() => store.state.usermedia.hasDeviceError)
const isAllowedPermissions = computed(() => permissions.value.video && permissions.value.audio)
const isRequestPermissions = computed(() =>
  (permissions.value.video === null || permissions.value.audio === null) && !hasDeviceError.value)

const useCastWelcome = () => {
  return {
    hasDeviceError,
    isAllowedPermissions,
    isRequestPermissions,
    requestAddParticipant
  }
}

export default useCastWelcome
